// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Promise from 'promise-polyfill';
import Vue from 'vue';
import App from './App';
import router from './router';

if (!window.Promise) {
  window.Promise = Promise;
}

Vue.config.productionTip = false;

router.afterEach(() => {
  // Mobile menu toggles
  if ($('ul.dropdown-menu').css('display') === 'block') {
    $('#dropdown-menu-button').click();
  }
  if ($('#mobile-menu-content').hasClass('in')) {
    $('#mobile-menu').click();
  }

  // ---- Revive Ads refresh (SPA-safe) ----
  setTimeout(() => {
    const rid = "251359c693f94c1d9c3e14a4b5099c8a";
    const o = window.reviveAsync && window.reviveAsync[rid];
    if (!o) return;

    // Assure le binding revive-id sur tous les emplacements
    document
      .querySelectorAll('ins[data-revive-zoneid]')
      .forEach(ins => {
        ins.setAttribute('data-revive-id', rid);
      });

    o.start({ detail: {} });
    o.refresh({ detail: {} });
  }, 0);
});


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  template: '<App/>',
  components: { App },
});



// WEBPACK FOOTER //
// ./src/main.js